// NavbarMenu.jsx
import React, { useState, useEffect } from "react";
import { Nav, Navbar, NavDropdown, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { HEADER_STYLE } from "../config/headerStyle";
import "../styles/header/opcion4-moderno-editorial.css";

const yearRange = (start, end) =>
  Array.from({ length: end - start + 1 }, (_, i) => end - i);

const acuerdosITEYears = yearRange(2015, 2025);
const acuerdosINEYears = [2025, 2024, 2023, 2022, 2021, 2020, 2016, 2015];
const boletinesYears = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2017, 2016, 2015];
const monitoreosYears = yearRange(2015, 2025);

const NavbarMenu = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => setExpanded(false), [location]);
  const handleLinkClick = () => setExpanded(false);

  const currentPath = (location.pathname || "").toLowerCase();
  const isHome = currentPath === "/" || currentPath === "";

  const isAcercaITEActive = [
    "/finesinstitucionales",
    "/historia",
    "/principiosrectores",
    "/estructuraorganica"
  ].some(p => currentPath.startsWith(p));

  const isConsejoGeneralActive = [
    "/integracion",
    "/comisiones",
    "/jge",
    "/estructura"
  ].some(p => currentPath.startsWith(p));

  const isDemarcacionesActive = [
    "/mapas",
    "/acuerdospj",
    "/mapaspj",
    "/distritacion"
  ].some(p => currentPath.startsWith(p)) || currentPath === "/acuerdos";

  const isAcuerdosActive = (
    currentPath.startsWith("/acuerdos") &&
    !currentPath.startsWith("/acuerdospj") &&
    currentPath !== "/acuerdos"
  );

  const isTransparenciaActive = [
    "/transparencia",
    "/infografias",
    "/preguntasfrecuentes",
    "/datosabiertos",
    "/articulo",
    "/art",
    "/obligaciones"
  ].some(p => currentPath.startsWith(p));

  const isComunicacionSocialActive = [
    "/boletines",
    "/monitoreos",
    "/iteconecta",
    "/encorto",
    "/galeria"
  ].some(p => currentPath.startsWith(p));

  const isCulturaCivicaActive = [
    "/actividadesludicas",
    "/eleccionesescolares",
    "/parlamentoinfantil",
    "/parlamentojuvenil",
    "/valoresdemocracia"
  ].some(p => currentPath.startsWith(p));

  const isArchivoActive = [
    "/instrumentosnormativos",
    "/planeacionarchivistica",
    "/instrumentosarchivisticos",
    "/inventariosdocumentales"
  ].some(p => currentPath.startsWith(p));

  const isLicitacionesActive = currentPath.startsWith("/licitaciones");

  return (
    <header className="hdr-op4-header" data-header-style={HEADER_STYLE}>
      <Navbar expanded={expanded} expand="lg" className="sticky-top hdr-op4-navbar">
        <Container>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
            className="border-0"
          />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
            <Nav className="mx-auto align-items-center">
              {/* Inicio / Home */}
              <Nav.Link
                as={Link}
                to="/"
                className={`hdr-op4-home-link ${isHome ? "hdr-op4-active" : ""}`}
                title="Inicio"
                aria-label="Ir al inicio"
                onClick={handleLinkClick}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="hdr-op4-home-icon-svg"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  {/* Icono de Casa estático y limpio */}
                  <path d="M12 2.5L2 11.5a1 1 0 0 0 1.34 1.48L4 12.36V20a1.5 1.5 0 0 0 1.5 1.5h4a1 1 0 0 0 1-1v-4.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V20a1 1 0 0 0 1 1h4a1.5 1.5 0 0 0 1.5-1.5v-7.64l.66.62a1 1 0 0 0 1.34-1.48L12 2.5z" />
                </svg>
              </Nav.Link>

              {/* Acerca de ITE */}
              <NavDropdown title="Acerca de ITE" id="acercaITE" className={isAcercaITEActive ? "hdr-op4-active" : ""}>
                {[["Fines Institucionales", "/FinesInstitucionales"],
                  ["Historia", "/Historia"],
                  ["Principios Rectores", "/PrincipiosRectores"],
                  ["Estructura Orgánica", "/EstructuraOrganica"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Consejo General */}
              <NavDropdown title="Consejo General" id="consejoGeneral" className={isConsejoGeneralActive ? "hdr-op4-active" : ""}>
                {[["Integración", "/Integracion"],
                  ["Comisiones Permanentes y Temporales", "/Comisiones"],
                  ["Junta General Ejecutiva", "/JGE"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Acuerdos */}
              <NavDropdown title="Acuerdos" id="acuerdos" className={isAcuerdosActive ? "hdr-op4-active" : ""}>
                <NavDropdown.ItemText className="text-secondary">Acuerdos ITE</NavDropdown.ItemText>
                <NavDropdown drop="end" title="Anteriores" id="anterioresITE">
                  <NavDropdown.Item as={Link} to="/AcuerdosAnteriores" onClick={handleLinkClick}>Mostrar todos</NavDropdown.Item>
                  <NavDropdown.Divider />
                  {acuerdosITEYears.map((year) => (
                    <NavDropdown.Item key={year} as={Link} to={`/Acuerdos${year}`} onClick={handleLinkClick}>
                      {year}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
                <NavDropdown.Item as={Link} to="/Acuerdos2026" onClick={handleLinkClick}>2026</NavDropdown.Item>

                <NavDropdown.Divider />
                <NavDropdown.ItemText className="text-secondary">Acuerdos INE</NavDropdown.ItemText>
                <NavDropdown drop="end" title="Anteriores" id="anterioresINE">
                  <NavDropdown.Item as={Link} to="/AcuerdosINE" onClick={handleLinkClick}>Mostrar todos</NavDropdown.Item>
                  <NavDropdown.Divider />
                  {acuerdosINEYears.map((year) => (
                    <NavDropdown.Item key={year} as={Link} to={`/AcuerdosINE${year}`} onClick={handleLinkClick}>
                      {year}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
                <NavDropdown.Item as={Link} to="/AcuerdosINE2026" onClick={handleLinkClick}>2026</NavDropdown.Item>
              </NavDropdown>

              {/* Demarcaciones */}
              <NavDropdown title="Demarcaciones" id="demarcaciones" className={isDemarcacionesActive ? "hdr-op4-active" : ""}>
                <NavDropdown.Item as={Link} to="/Acuerdos" onClick={handleLinkClick}>Acuerdos</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Mapas" onClick={handleLinkClick}>Mapas</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/AcuerdosPJ" onClick={handleLinkClick}>Acuerdos Poder Judicial</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/MapasPJ" onClick={handleLinkClick}>Mapas Poder Judicial</NavDropdown.Item>
              </NavDropdown>

              {/* Transparencia */}
              <NavDropdown title="Transparencia" id="transparencia" className={isTransparenciaActive ? "hdr-op4-active" : ""}>
                {[["Transparencia", "/Transparencia"],
                  ["Infografías", "/Infografias"],
                  ["Preguntas Frecuentes", "/PreguntasFrecuentes"],
                  ["Datos Abiertos", "/DatosAbiertos"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Comunicación Social */}
              <NavDropdown title="Comunicación Social" id="comunicacionSocial" className={isComunicacionSocialActive ? "hdr-op4-active" : ""}>
                <NavDropdown drop="end" title="Boletines" id="boletinesITE">
                  {boletinesYears.map((year) => (
                    <NavDropdown.Item key={year} as={Link} to={`/Boletines${year}`} onClick={handleLinkClick}>{year}</NavDropdown.Item>
                  ))}
                </NavDropdown>
                <NavDropdown drop="end" title="Monitoreos" id="monitoreosITE">
                  {monitoreosYears.map((year) => (
                    <NavDropdown.Item key={year} as={Link} to={`/Monitoreos${year}`} onClick={handleLinkClick}>{year}</NavDropdown.Item>
                  ))}
                  <NavDropdown.Item as={Link} to="/MonitoreosPELE2024" onClick={handleLinkClick}>PELE 2024</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown.Item as={Link} to="/ITEConecta" onClick={handleLinkClick}>ITE Conecta</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/EnCorto" onClick={handleLinkClick}>En Corto</NavDropdown.Item>
              </NavDropdown>

              {/* Cultura Cívica */}
              <NavDropdown title="Cultura Cívica" id="culturaCivica" className={isCulturaCivicaActive ? "hdr-op4-active" : ""}>
                {[["Actividades Lúdicas", "/ActividadesLudicas"],
                  ["Elecciones Escolares", "/EleccionesEscolares"],
                  ["Parlamento Infantil", "/ParlamentoInfantil"],
                  ["Parlamento Juvenil", "/ParlamentoJuvenil"],
                  ["Valores de la Democracia", "/ValoresDemocracia"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>{label}</NavDropdown.Item>
                ))}
                <NavDropdown.Item href="https://itetlax.org.mx/assets/pdf/ccivica/2.pdf" target="_blank" rel="noopener noreferrer">
                  Catálogo de Acciones en Educación Cívica
                </NavDropdown.Item>
              </NavDropdown>

              {/* Archivo */}
              <NavDropdown title="Archivo" id="archivo" className={isArchivoActive ? "hdr-op4-active" : ""}>
                {[["Instrumentos Normativos", "/InstrumentosNormativos"],
                  ["Planeación Archivística", "/PlaneacionArchivistica"],
                  ["Instrumentos Archivísticos", "/InstrumentosArchivisticos"],
                ].map(([label, path]) => (
                  <NavDropdown.Item as={Link} to={path} key={path} onClick={handleLinkClick}>{label}</NavDropdown.Item>
                ))}
              </NavDropdown>

              {/* Enlaces adicionales */}
              <Nav.Link as={Link} to="/Licitaciones" className={isLicitacionesActive ? "hdr-op4-active" : ""} onClick={handleLinkClick}>Licitaciones</Nav.Link>
              <Nav.Link href="https://encuesta-satisfaccion.itetlax.org.mx/" target="_blank" rel="noreferrer" style={{ fontSize: '0.85rem', padding: '0.25rem 0.75rem', margin: '0 auto', display: 'block', textAlign: 'center' }}>Encuesta de Satisfacción</Nav.Link>

              </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default NavbarMenu;